import React from 'react'

const ICONS = { breakfast: '🥐', lunch: '🥗', dinner: '🍝' }

export function DaySummary({ slots, mealTypes }) {
  const planned = slots.filter((s) => s.status !== 'skipped')
  const totalPrep = planned.reduce((sum, s) => sum + (s.prep_time ?? 0), 0)

  return (
    <div className="flex items-center gap-2 mt-2 px-1 text-xs text-gray-500">
      <div className="flex gap-1">
        {mealTypes.map((type) => {
          const slot = slots.find((s) => s.meal_type === type)
          const filled = slot && slot.status !== 'skipped'
          return (
            <span
              key={type}
              className={`text-base leading-none ${filled ? 'opacity-100' : 'opacity-25'}`}
              title={type}
              aria-label={`${type} ${filled ? 'planifié' : 'vide'}`}
            >
              {ICONS[type] ?? '🍽️'}
            </span>
          )
        })}
      </div>
      <span className="text-gray-300">·</span>
      <span>
        {planned.length} repas
        {totalPrep > 0 && ` · ~${totalPrep} min`}
      </span>
    </div>
  )
}
